export enum LeadFormWebhooksEnum {
	ZFT = '/api/lead/zft',
	SGT = '/api/lead/sgt',
	PGT = '/api/lead/pgt',
	PT = '/api/lead/pt',
	SgtTrial = '/api/lead/sgt-trial',
}
